/* global BigInt */
import { currencyScale, moneyFromDecimal } from '../../../shared/money/exact-money.js';

export function readVerificationSettings(response) {
  const settings = response?.verificationSettings;
  if (typeof settings?.allowLiveAccountBeforeVerification !== 'boolean'
    || typeof settings?.allowDepositBeforeVerification !== 'boolean'
    || typeof settings?.depositLimitAmount !== 'string'
    || !/^[1-9]\d*$/.test(settings.depositLimitAmount)
    || BigInt(settings.depositLimitAmount) > BigInt(Number.MAX_SAFE_INTEGER)
    || !/^[A-Z]{3}$/.test(settings.depositLimitCurrency || '')
    || !Number.isInteger(settings.verificationDays) || settings.verificationDays < 1 || settings.verificationDays > 365) {
    throw new Error('verificationSettings.invalidResponse');
  }
  const scale = currencyScale(settings.depositLimitCurrency);
  const digits = settings.depositLimitAmount.padStart(scale + 1, '0');
  return {
    allowLiveAccountBeforeVerification: settings.allowLiveAccountBeforeVerification,
    allowDepositBeforeVerification: settings.allowDepositBeforeVerification,
    depositLimitAmount: scale ? `${digits.slice(0, -scale)}.${digits.slice(-scale)}` : digits,
    depositLimitCurrency: settings.depositLimitCurrency,
    verificationDays: String(settings.verificationDays),
  };
}

export function buildVerificationSettingsPayload(form) {
  const errors = {};
  const currency = String(form.depositLimitCurrency || '').trim().toUpperCase();
  if (!/^[A-Z]{3}$/.test(currency)) errors.depositLimitCurrency = 'verificationSettings.currencyError';
  const money = moneyFromDecimal(String(form.depositLimitAmount || '').trim(), currency);
  const scale = currencyScale(currency);
  let amount = null;
  if (money && money.scale <= scale) amount = BigInt(money.units) * (BigInt(10) ** BigInt(scale - money.scale));
  if (amount === null || amount <= BigInt(0) || amount > BigInt(Number.MAX_SAFE_INTEGER)) errors.depositLimitAmount = 'verificationSettings.amountError';
  const days = String(form.verificationDays || '').trim();
  if (!/^\d+$/.test(days) || Number(days) < 1 || Number(days) > 365) errors.verificationDays = 'verificationSettings.daysError';
  return {
    errors,
    payload: Object.keys(errors).length ? null : {
      allowLiveAccountBeforeVerification: form.allowLiveAccountBeforeVerification,
      allowDepositBeforeVerification: form.allowDepositBeforeVerification,
      depositLimitAmount: amount.toString(),
      depositLimitCurrency: currency,
      verificationDays: Number(days),
    },
  };
}
